<template>
  <GuidelineAnalyteDefaultValues @notify="$emit('notify', $event)" :mapSameAnalyte="mapSameAnalyte"/>
</template>

<script>
  import GuidelineAnalyteDefaultValues from '@/components/CoFactorManage/GuidelineAnalyteDefaultValues'
  export default {
    components: {
      GuidelineAnalyteDefaultValues,
    },
    props: {
      mapSameAnalyte: {
        type: Array,
        default: () => [],
      },
    },
  }
</script>